$(document).ready(function() {
  setTimeout(function() {
    var compare_price = $('.price_crossed_out').text();
    var price_current = $('.price_current').text();
    var purchase_type = $('[name="purchase_type"]:checked').val();
    var wipes = $('[name="refill_plan_variant_id"]:checked').val();
    var pricesJson = $('#productPrices').html();

    if (compare_price != price_current) {
      if (!$('.crossed_out_price').hasClass('sale')) {
        $('.crossed_out_price').addClass('sale');
      }
    } else {
      $('.crossed_out_price').removeClass('sale');
    }

    if (purchase_type == 'autodeliver') {
      $('.wipes-selector-wrapper').show();

      // set price
      if (pricesJson != undefined) {
        var prices = $.parseJSON(pricesJson);

        console.log(wipes);

        if (wipes == '39891364839592') {
          $('.price_current').html(Shopify.formatMoney(prices['refill_subscription']['wipes'], $('body').data('money-format')));

          if (prices['refill_subscription']['wipes_sale'] != 0) {
            $('.price_crossed_out').html(Shopify.formatMoney(prices['refill_subscription']['wipes_sale'], $('body').data('money-format')));
            $('.crossed_out_price').show();
          } else {
            $('.crossed_out_price').hide();
          }
        } else {
          $('.price_current').html(Shopify.formatMoney(prices['refill_subscription']['no_wipes'], $('body').data('money-format')));
          if (prices['refill_subscription']['no_wipes_sale'] != 0) {
            $('.price_crossed_out').html(Shopify.formatMoney(prices['refill_subscription']['no_wipes_sale'], $('body').data('money-format')));
            $('.crossed_out_price').show();
          } else {
            $('.crossed_out_price').hide();
          }
        }
      }

      $('#green-notification').fadeIn();
      $('#green-notification').addClass('active');
      if ($('.price_crossed_out-subscription-no-wipes').length) {
        if ($('input[value="Add Wipes"]').is(':checked')) {
          $('.price_crossed_out-subscription-add-wipes').show();
          $('.price_crossed_out-subscription-no-wipes').hide();
        } else {
          $('.price_crossed_out-subscription-add-wipes').hide();
          $('.price_crossed_out-subscription-no-wipes').show();
        }
      } else {
        $('.price_crossed_out-subscription').show();
      }
      $('.price_crossed_out-regular').hide();
    } else {
      // set price
      if (pricesJson != undefined) {
        var prices = $.parseJSON(pricesJson);
        $('.price_current').html(Shopify.formatMoney(prices['intake_otp']['regular'], $('body').data('money-format')));

        if (prices['intake_otp']['sale'] != 0) {
          $('.price_crossed_out').html(Shopify.formatMoney(prices['intake_otp']['sale'], $('body').data('money-format')));
          $('.crossed_out_price').show();
        } else {
          $('.crossed_out_price').hide();
        }
      }


      $('.wipes-selector-wrapper input[value="No Wipes"]').trigger('click');
      $('.wipes-selector-wrapper').hide();

      $('#red-notification').fadeIn();
      $('#red-notification').addClass('active');
      $('.price_crossed_out-regular').show();
      $('.price_crossed_out-subscription').hide();
    }
  },1800);
  
  $('.shopify-product-form').on('change', function() {
    setTimeout(function() {
      var compare_price = $('.price_crossed_out').text();
      var price_current = $('.price_current').text();
      var purchase_type = $('[name="purchase_type"]:checked').val();
      var wipes = $('[name="refill_plan_variant_id"]:checked').val();
      var pricesJson = $('#productPrices').html();

      if (compare_price != price_current) {
        if (!$('.crossed_out_price').hasClass('sale')) {
          $('.crossed_out_price').addClass('sale');
        }
      } else {
        $('.crossed_out_price').removeClass('sale');
      }

      if (purchase_type == 'autodeliver') {
        $('.wipes-selector-wrapper').show();
        
        $('.price_crossed_out-regular').hide();
        if ($('.price_crossed_out-subscription-no-wipes').length) {
          if ($('input[value="Add Wipes"]').is(':checked')) {
            $('.price_crossed_out-subscription-add-wipes').show();
            $('.price_crossed_out-subscription-no-wipes').hide();
          } else {
            $('.price_crossed_out-subscription-add-wipes').hide();
            $('.price_crossed_out-subscription-no-wipes').show();
          }
        } else {
          $('.price_crossed_out-subscription').show();
        }

        // set price
        if (pricesJson != undefined) {
          var prices = $.parseJSON(pricesJson);

          if (wipes == '39891364839592') {
            $('.price_current').html(Shopify.formatMoney(prices['refill_subscription']['wipes'], $('body').data('money-format')));

            if (prices['refill_subscription']['wipes_sale'] != 0) {
              $('.price_crossed_out').html(Shopify.formatMoney(prices['refill_subscription']['wipes_sale'], $('body').data('money-format')));
              $('.crossed_out_price').show();
            } else {
              $('.crossed_out_price').hide();
            }
          } else {
            $('.price_current').html(Shopify.formatMoney(prices['refill_subscription']['no_wipes'], $('body').data('money-format')));

            if (prices['refill_subscription']['no_wipes_sale'] != 0) {
              $('.price_crossed_out').html(Shopify.formatMoney(prices['refill_subscription']['no_wipes_sale'], $('body').data('money-format')));
              $('.crossed_out_price').show();
            } else {
              $('.crossed_out_price').hide();
            }
          }
        }

        if (!$('#green-notification').hasClass('active')) {
          $('#red-notification').removeClass('active');
          $('#red-notification').hide();
          $('#green-notification').fadeIn();
          $('#green-notification').addClass('active');
        }
      } else {
        $('.wipes-selector-wrapper').hide();

        // set price
        if (pricesJson != undefined) {
          var prices = $.parseJSON(pricesJson);
          $('.price_current').html(Shopify.formatMoney(prices['intake_otp']['regular'], $('body').data('money-format')));

          if (prices['intake_otp']['sale'] != 0) {
            $('.price_crossed_out').html(Shopify.formatMoney(prices['intake_otp']['sale'], $('body').data('money-format')));
            $('.crossed_out_price').show();
          } else {
            $('.crossed_out_price').hide();
          }
        }

        $('.price_crossed_out-regular').show();
        $('.price_crossed_out-subscription').hide();
        if (!$('#red-notification').hasClass('active')) {
          $('#green-notification').removeClass('active');
          $('#green-notification').hide();
          $('#red-notification').fadeIn();
          $('#red-notification').addClass('active');
        }
      }
    });
  });
});

$(document).ready(function() {
  $('.product-refill-new input[value="No Wipes"]').trigger('click');
});